<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="row">
    <div class="col-24">
        <h1 class="medium">Confirm the Enrollment Details Below</h1>
    </div>
</div>
<div class="row" *ngIf="hasError" aria-live="polite" tabindex="0" role="alert">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul role="list">
                <li role="listitem" *ngFor="let error of ErrorMessages" aria-atomic="true">{{ error }}</li>
            </ul>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p class="bottom-20">Please review the following information, and click the button at the bottom of the page to submit the application for your client, or click to go back and edit details.</p>
    </div>
    <div class="col-16">
        <p class="red-text"><strong>Please note that your enrollment has not yet been submitted. Please review the data and click the submit button at the bottom of the page to complete the enrollment.</strong></p>
    </div>
</div>


<div class="row">
    <div class="col-16">
        <table class="without-stripe all-border">
            <tr>
                <th scope="row">Agent ID</th>
                <td>
                    {{enrollment.AGENTNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row">Data Entry ID</th>
                
                <td>
                    {{enrollment.USERNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row">Title</th>
                <td>
                    {{enrollment.TITLE}}

                </td>
            </tr>
            <tr>
                <th scope="row">First Name</th>
               
                <td>
                    {{enrollment.APPFN}}
                </td>
            </tr>
            <tr>
                <th scope="row">Middle Initial</th>
                <td>
                    {{enrollment.APPMI}}
                </td>
            </tr>
            <tr>
                <th scope="row">Last Name</th>
                
                <td>
                    {{enrollment.APPLN}}
                </td>
            </tr>
            <tr>
                <th scope="row">Medicare Number</th>
               
                <td>
                    {{enrollment.HICN}}
                </td>
            </tr>
            <tr>
                <th scope="row">Application Date</th>
                <td>
                    {{appDate}}
                </td>
            </tr>
            <tr>
                <th scope="row">Effective Date</th>
               
                <td>
                    {{effDate}}
                </td>
            </tr>
            <tr>
                <th scope="row">Applicant State</th>
                
                <td>
                    {{enrollment.APPST}}
                </td>
            </tr>
            <tr>
                <th scope="row">Selected Plan</th>
                
                <td>
                    {{enrollment.PLANTYPENAME}}
                </td>
            </tr>
            <tr>
                <th scope="row"> CUID</th>
                
                <td>
                    {{enrollment.CUID}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Carrier</th>
               
                <td>
                    {{enrollment.CARRIER}}
                </td>
            </tr>
            <tr>
                <th scope="row">Account</th>
                
                <td>
                    {{enrollment.ACCOUNT}}
                </td>
            </tr>
            <tr>
                <th scope="row">Group</th>
                
                <td>
                    {{enrollment.GROUP}}
                </td>
            </tr>
            <tr>
                <th scope="row">Election Period</th>
                <td>
                    {{enrollment.ELECTION}}
                </td>
            </tr>
            <tr>
                <th scope="row">Enrollment Criteria</th>
                
                <td>
                    {{enrollment.SEPREASONCD}} - {{enrollment.SEPREASONTEXT}}
                </td>
            </tr>
            <tr *ngIf="showSepEffDate">
                <th scope="row">SEP Date</th>
                <td>
                    {{sepEffDate}}
                </td>
            </tr>
            <tr>
                <th scope="row">Enrollment Type</th>
                
                <td>
                    {{enrollment.AGENTDEX}}
                </td>
            </tr>
            <tr>
                <th scope="row">Phone Number</th>
               
                <td>
                    {{enrollment.APPPHONE}}
                </td>
            </tr>
            <tr>
                <th scope="row">Cell Phone</th>
                
                <td>
                    {{enrollment.CELLPHONE}}
                </td>
            </tr>
            <tr>
                <th scope="row">Date of Birth</th>
               
                <td>
                    {{dob}}
                </td>
            </tr>
            <tr>
                <th scope="row">Sex</th>
                
                <td>
                    {{gender}}
                </td>
            </tr>

            <tr>
               
                <th scope="row">Email</th>
                
                <td>
                    {{
enrollment.APPEMAIL
                    }}
                </td>
            </tr>
            <tr>
                <th scope="row">Permanent Address 1</th>
                
                <td>
                    {{enrollment.APPADD1}}
                </td>
            </tr>
            <tr>
                <th scope="row">Permanent Address 2</th>
                
                <td>
                    {{enrollment.APPADD2}}
                </td>
            </tr>
            <tr>
                <th scope="row">Permanent City</th>
                
                <td>
                    {{enrollment.APPCITY}}
                </td>
            </tr>
            <tr>
                <th scope="row">Permanent State</th>
               
                <td>
                    {{enrollment.APPST}}
                </td>
            </tr>
            <tr>
                <th scope="row">Permanent Zip</th>
                
                <td>
                    {{enrollment.APPZIP}}
                </td>
            </tr>
            <tr *ngIf="visibleFrom2026">
                <th scope="row">PO Box Override</th>
               
                <td>
                    {{poBoxOverride}}
                </td>
            </tr>
            <tr>
                <th scope="row">Mailing Address 1</th>
               
                <td>
                    {{enrollment.MAILADD1}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Mailing Address 2</th>
                
                <td>
                    {{enrollment.MAILADD2}}
                </td>
            </tr>
            <tr>
                <th scope="row">Mailing City</th>
                
                <td>
                    {{enrollment.MAILCITY}}
                </td>
            </tr>
            <tr>
                <th scope="row">Mailing State</th>
                
                <td>
                    {{enrollment.MAILST}}
                </td>
            </tr>
            <tr>
                <th scope="row">Mailing Zip</th>
                
                <td>
                    {{enrollment.MAILZIP}}
                </td>
            </tr>
            <tr>
                <th scope="row">Long-term Care Name</th>
                
                <td>
                    {{enrollment.LTCFACILITY}}
                </td>
            </tr>
            <tr>
                <th scope="row">Long-term Care Phone</th>
               
                <td>
                    {{enrollment.LTCPHONE}}
                </td>
            </tr>
            <tr>
                <th scope="row">Address of Facility</th>
                
                <td>
                    {{enrollment.LTCADD1}}
                </td>
            </tr>
            <tr>
                <th scope="row">Medicare Part A Date</th>
                
                <td>
                    {{medAdate}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Medicare Part B Date</th>
               
                <td>
                    {{medBDate}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Premium Payment Type</th>
                
                <td>
                    {{enrollment.PWO}}
                </td>
            </tr>
            <tr>
                <th scope="row">Language Preference</th>
                
                <td>
                    {{enrollment.LANG}}
                </td>
            </tr>
            <tr *ngIf="!Showfor2023">
                <th scope="row">Accessible Communications Format</th>
               
                <td>
                    {{Accessible}}
                </td>
            </tr>
            <!--<tr *ngIf="PaperlessOption">
        <td>
            Receives Paperless Documents
        </td>
        <td>
            {{EOBFlag}}
        </td>
    </tr>-->
            <tr *ngIf="!Script2020">
                <th scope="row"> Enrollee Work Status</th>
               
                <td>
                    {{enrollment.ENROLLEEWORKSTATUS}}
                </td>
            </tr>
            <tr *ngIf="!Script2020">
                <th scope="row">Spouse Work Status</th>
                
                <td>
                    {{enrollment.SPOUSEWORKSTATUS}}
                </td>
            </tr>
            <tr>
                <th scope="row">Secondary Coverage Name</th>
                
                <td>
                    {{enrollment.OTHCVRGNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Secondary Coverage ID</th>
               
                <td>
                    {{enrollment.OTHCVRGID}}
                </td>
            </tr>

            <tr>
                <th scope="row">Secondary Coverage Group</th>
               
                <td>
                    {{enrollment.OTHCVRGGRP}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative Name</th>
               
                <td>
                    {{enrollment.AUTHREPNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative Phone</th>
                
                <td>
                    {{enrollment.AUTHREPPHONE}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative Relationship</th>
                
                <td>
                    {{enrollment.AUTHREPREL}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative Address</th>
               
                <td>
                    {{enrollment.AUTHREPADD1}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative City</th>
               
                <td>
                    {{enrollment.AUTHREPCITY}}
                </td>
            </tr>
            <tr>
                <th scope="row">Authorized Representative State</th>
               
                <td>
                    {{enrollment.AUTHREPST}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Authorized Representative Zip</th> 
                <td>
                    {{enrollment.AUTHREPZIP}}
                </td>
            </tr>
            <ng-container *ngIf="visibleFrom2025">
               
                <tr>
                    <th scope="row"> Individual Rep Name</th>
                    <td>
                        {{enrollment.INDREPNAME}}
                    </td>
                </tr>
                <tr>
                    <th scope="row">Relationship to enrollee</th>
                   
                    <td>
                        {{enrollment.displayRELTOENROLL}}
                    </td>
                </tr>
                <tr>
                    <th scope="row">National Producer Number</th>
                    
                    <td>
                        {{enrollment.NPN}}
                    </td>
                </tr>
            </ng-container>
            <tr>
                <th scope="row"> Name on Account</th>
               
                <td>
                    {{enrollment.ACCHOLDERNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row">Account Type</th>
               
                <td>
                    {{AccountType}}
                </td>
            </tr>
            <tr>
                <th scope="row">Routing Number</th>
               
                <td>
                    {{enrollment.ROUTINGNB}}
                </td>
            </tr>
            <tr>
                <th scope="row">Financial Institution</th>
               
                <td>
                    {{enrollment.FININSTNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row">Account Number</th>
               
                <td>
                    {{enrollment.ACCOUNTNB}}
                </td>
            </tr>
            <tr>
                <th scope="row">Emergency contact</th>
                
                <td>
                    {{enrollment.EMERNAME}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Emergency Phone Number</th>
               
                <td>
                    {{enrollment.EMERPHONE}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Relationship to You</th>
                
                <td>
                    {{enrollment.EMERREL}}
                </td>
            </tr>
            <tr>
                <th scope="row"> Notes</th>
               
                <td>
                    {{enrollment.NOTES}}
                </td>
            </tr>
            <tr *ngIf="!visibleFrom2026">
                <th scope="row"> Ethnicity</th>
               
                <td>
                    {{enrollment.displayEthnicity}}
                </td>
            </tr>
            <tr *ngIf="!visibleFrom2026">
                <th scope="row">Race</th>
               
                <td>
                    {{enrollment.displayRace}}
                </td>
            </tr>
            <!--<tr *ngIf="visibleFrom2025">
        <td>
            Gender Identity
        </td>
        <td>
            {{enrollment.displayCurrentGender}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>
            Different Gender Identity
        </td>
        <td>

            {{enrollment.CURRENTGENDEROTH}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>

            Self Identify
        </td>
        <td>

            {{enrollment.displayGenderProNoun}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>

            Different Self Identify
        </td>
        <td>

            {{enrollment.GENDERNPRONOUNOTH}}
        </td>
    </tr>-->

        </table>

    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="formSubmit()"> Submit My Client's Applications</button>
        <button class="button cancel" (click)="goBack()">Go Back</button>
    </div>
</div>


